module.exports = __webpack_public_path__ + "img/ereszkalkulator_kicsi_haz_felnyeregteto_szurke.24e86273.png";